import { render, staticRenderFns } from "./SavedFolders.vue?vue&type=template&id=204bb35c"
import script from "./SavedFolders.vue?vue&type=script&setup=true&lang=ts"
export * from "./SavedFolders.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports